module.exports = __webpack_public_path__ + "static/media/stretcher.6ce284ca.svg";